var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-skeleton-item',{style:(`min-width: ${_vm.width}; width: ${_vm.width}; height: ${_vm.height}; max-width: ${_vm.maxWidth}`),attrs:{"variant":_vm.variant}})
}
var staticRenderFns = []

export { render, staticRenderFns }